export { default as StrategyMapControls } from './StrategyMapControls';
